export default __webpack_public_path__ + "static/media/product-2.49ee6137.jpg";